<template>
  <section class="documents-section">
    <div class="resources-container" v-if="loading">
      <div class="category-name">
        <div class="skeleton-box" style="width: 20%; height: 16px; border-radius: 10px;"></div>
      </div>
      <div class="documents-grid">
          <v-skeleton-loader elevation="2" class="card-loader document-card" v-for="index in 4" :key="index"
                  type="heading, list-item, actions"></v-skeleton-loader>
      </div>
    </div>
    <div class="resources-container" v-else>
      <div class="category-name">
        <h2> {{ this.category }}</h2>
        <div class="documents-grid" v-if="documents.length">
          <div class="document-card" v-for="(document, index) in documents" :key="index">
            <h3>{{ document.title }}</h3>
            <p>{{ document.short_description }}</p>
            <div class="buttons">
              <button class="preview-btn" v-if="document.url" @click="showDocument(document.url)">Preview Document</button>
              <button :class="[isQuickResources ? 'q-play-btn' : 'play-btn']" v-if="document.video_url" @click="openDocument(document)">Play Video</button>
            </div>
          </div>
        </div>
        <div v-else>
          No resources available at the moment.
        </div>
      </div>
      <div class="support-banner">
          <a
            :href="$globalConfig.APP_NAME === 'senso' ? 'mailto:learn@senso.cloud?subject=Customer%20Inquiry&body=Hello%20Senso%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20...' : 'mailto:info@improve.online?subject=Customer%20Inquiry&body=Hello%20Improve%20Team,%0A%0AI%20would%20like%20to%20inquire%20about%20...'">
            <!-- Desktop Image -->
            <v-img v-if="$vuetify.breakpoint.mdAndUp" :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-help-and-support-banner-desktop.png' : '/static/resources/help-and-support-banner-desktop.png'"
              alt="help and support banner"></v-img>

            <!-- Tablet Image -->
            <v-img v-else-if="$vuetify.breakpoint.smAndUp && $vuetify.breakpoint.smAndDown"
              :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-help-and-support-banner-tablet.png' : '/static/resources/help-and-support-banner-tablet.png'" alt="help and support banner"></v-img>

            <!-- Mobile Image -->
            <v-img v-else :src="$globalConfig.APP_NAME === 'senso' ? '/static/resources/senso-help-and-support-banner-mobile.png' : '/static/resources/help-and-support-banner-mobile.png'"
              alt="help and support banner"></v-img>
          </a>
        </div>
    </div>
    <v-dialog v-model="isOpen" max-width="750px" persistent>
      <v-card>
        <v-card-title class="dialog-title">
          <span>{{ this.resourseTitle }}</span>
        </v-card-title>
          <v-container class="dialog-container">
            <v-row justify="center">
              <div class="text-center" v-if="!this.isVideo && !this.iframLoading" fluid style="position: relative;width: 100%;margin-top: 25px;">
                <v-skeleton-loader type="image"></v-skeleton-loader>
              </div>
              <v-col lg="10" md="10" sm="10">
                <video-player
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  class="vjs-big-play-centered mt-3"
                  style="border:3px solid #162b44;"
                  v-if="isVideo && this.videoUrl !=''"
                />
                <div style="position: relative;" v-if="!this.isVideo">
                  <iframe :src="this.videoUrl" style="width:100%;height: 640px; border:0px;" :class="{'hidden': !this.iframLoading}" @load="onIframeLoad"></iframe>
                </div>
                </v-col>
                </v-row>
            </v-container>
        <v-card-actions class="btn-section">
          <v-btn class="mr-1 mb-2 add-course-button"
          color="primary" outlined @click="closeDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import userAPI from '@/api/user.js';
import ResourceDatail from '@/components/ResourceDatail';
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';

export default {
  name: 'DocumentsComponent',
  components: {
    videoPlayer,
  },
  data() {
    return {
      documents: [],
      categoryId: this.$route.params.id,
      loading: false,
      category: '',
      isOpen: false,
      resourseTitle: '',
      videoUrl: '',
      isVideo: true,
      iframLoading: false
    }
  },
  mounted() {
    this.getAllResources();
  },
  computed: {
    isQuickResources: function(){
      return this.categoryId ? false : true;
    },
    playerOptions: function() {
      return {
        autoplay: false,
        preload: 'auto',
        responsive: true,
        aspectRatio: '16:9',
        controls: true,
        sources: [
          {
            type: 'video/mp4',
            src: this.videoUrl,
          },
        ],
      };
    },
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    getAllResources() {
      this.loading = true;
      if(this.categoryId){
      userAPI
        .getResources(this.categoryId)
        .then((resp) => {
          this.documents = resp.data.data;
          this.category = resp.data.categoryName;
          this.loading = false;
        });
      }else{
        userAPI
        .getQuickResources()
        .then((resp) => {
          this.documents = resp.data.data;
          this.category = 'Quick Resources';
          this.loading = false;
        });
      }
    },
    openDocument(data) {
      this.resourseTitle = data.title;
      this.videoUrl = data.video_url;
      this.isOpen = true;
      if(this.videoUrl.includes("scribehow.com")){
        this.isVideo = false;
      }
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    showDocument(url) {
      this.$showPanel({
        component: ResourceDatail,
        disableBgClick: true,
        props: {
          url: url
        },
        openOn: 'right',
      });
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.isOpen = false;
      if(this.isVideo){
          this.player.currentTime(0);
          this.player.pause()
      }
      this.videoUrl = '';
      this.isVideo = true;
      this.iframLoading = false;
    },
    onIframeLoad(){
      this.iframLoading = true;
    }
  }
}
</script>

<style scoped>
.document-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.document-card h3 {
  font-size: 1.5em;
  margin-bottom: 10px;
}

.document-card p {
  font-size: 1em;
  color: #666;
  margin-bottom: 20px;
}

.buttons {
  display: flex
}

.preview-btn,
.play-btn,.q-play-btn {
  padding: 5px 15px;
  border-radius: 5px;
  cursor: pointer;
  text-transform: uppercase;
  font-family: 'Roboto';
  letter-spacing: 1px;
  font-size: 12px;
}

.preview-btn {
  background-color: #fff;
  color: #000000;
  border: 1px solid #000000;
  margin-right: 15px;
}

.preview-btn:hover {
  background-color: #e6f4ff;
}

.dialog-container{
  width: 95%;
}

.q-play-btn{
  background-color: #162c44;
  color: #fff;
  border: none;
}
.q-play-btn:hover {
  background-color: #162c44;
  color: #fff !important;
  opacity: 1;
}
.hidden{
  display: none;
}
</style>